import { Component, Output, EventEmitter, OnInit, Input, QueryList, ViewChildren, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { MicroempresarioService } from '../../services/microempresario.service';
import { ParametrosService } from '../../../services/parametros.service';
import { UserService } from '../../../services/user.service';
import {BancoldexService} from 'src/app/comun/services/bancoldex.service';
import {ModalService} from "../../../shared/service/modal.service";
import { SweetAlertService } from '../../../services/sweet-alert.service';
import { Location } from '@angular/common';
import { DataUrl, NgxImageCompressService } from 'ngx-image-compress';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {TooltipDirective} from "ngx-bootstrap/tooltip";
declare var $: any;
//Constantes
const mensajeEnvioSolicitud = 'PAR-077';
@Component({
    selector: 'files-form',
    templateUrl: './files.form.html',
    styleUrls: ['./files.form.scss'],
    standalone: false
})
export class FileForm implements OnInit {
  @ViewChildren('tooltipGuia') tooltipsGuia: QueryList<TooltipDirective>;
  @Output() event = new EventEmitter<string>();
  @Input() isExpress = false;
  @Input() idEstadoSolicitud = 1;
  idSolicitud: string;
  tipoPersona: string = '';
  documentos: any[] = [];
  fotosObligatorio: boolean = false;
  fotosOpcional: boolean = false;
  //archivosAWS: any[] = [];
  //fotos: any [] = [];
  video: any;
  cantFilesUpload: number = 0;
  cantFiles: number = 0;
  cantPhotosUpload: number = 0;
  habilitarBoton: boolean = false;
  tamanoMaximoArchivos: Number = null;
  tamanoMaximoArchivosReal: Number = null;
  tamanoMaximoArchivosMultimedia: Number = null;
  tamanoMaximoArchivosMultimediaReal: Number = null;
  nombreArchivos: any[] = [];
  foto: boolean;
  mensajeEnvio: string;
  multiples: Map<any,any> = new Map();
  tipoSolicitud:string;
  listadoEncabesadosSecciones: any[]=[];
  idEmpresario:number;
  porcentajeProcesoSolicitud: number = 0;
  msjDocumentosAdicionales:string;
  msjObservacionesMicro: string;
  msjDocumentosErroneos: string;
  isDocumentos: boolean = false;
  // doc invalidos
  invalidFile: number=0;
  observacionesForm: UntypedFormGroup;
  archivoSeleccionado: string | ArrayBuffer;
  constructor(
    private _microempresario: MicroempresarioService,
    public _modal: ModalService,
    private route: Router,
    private _parametro: ParametrosService,
    private _user: UserService,
    private _bancoldexService: BancoldexService,
    private _sweetAlert:SweetAlertService,
    private _location: Location,
    private imageCompress: NgxImageCompressService,
    private formBuilder: UntypedFormBuilder,
  ) {
    this.idSolicitud = this._user.getUser().idSolicitud;
    this.getMensajeEnvio();
    window.scroll(0, 0);
    this.observacionesForm = this.formBuilder.group({
      idSolicitud: this.idSolicitud,
      observacionesMicroempresario: ['']
    });
    //estilos tooltip
    $(function () {
      $('[data-bs-toggle="tooltip"]').tooltip({
        boundary: 'window',
        template:
          '<div class="tooltip tooltip-custom" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
      });
    });
  }

  ngOnInit(): void {
    this.cargarMsjDocumentosAdicionales();
    this.mensajeObservaciones();
    this.mensajeDocumentosErroneos();
    this.cargarObservaciones();
    this.tipoPersona = this._user.getUser().tipoPersona;
    this.idEmpresario = +this._user.getUser().idEmpresario;
    this.cargarTamanoArchivo();
    this.cargarTamanoArchivoMultimedia();
    this.getDocumentos();
  }

  mostrarTooltips() {
    let aux = 0;
    const tooltipsArray = this.tooltipsGuia?.toArray();
    tooltipsArray.forEach((tooltip, index) => {
      const element = tooltip['elementRef']?.nativeElement;
      if (element) {
        const idDocumento = element.getAttribute('data-id-documento');
        if (idDocumento) {
          const documento = this.findDocumentoById(+idDocumento);
          if (documento) {
            if (this.shouldShowTooltip(documento)) {
              setTimeout(() => {
                if (aux == 0 || aux == idDocumento) {
                  tooltip.show();
                  aux = idDocumento;
                  setTimeout(() => {
                    tooltip.hide();
                  }, 10000);
                }
              });
            }
          }
        }
      }
    });
  }

  shouldShowTooltip(documento: any): boolean {
    return ((documento.habilitado === 0 &&
           documento?.multiple === false) || documento?.habilitado === 0);
  }

  findDocumentoById(id: number): any | undefined {
    for (const doc of this.documentos['archivos']) {
      if (doc.neoDocumentosSolicitudDTO) {
        const subdoc = doc.neoDocumentosSolicitudDTO.find((subdoc: any) =>
          subdoc.idDocumentoSolicitud === id
        );
        if (subdoc) {
          return subdoc;
        }
      }
    }
    return undefined;
  }

  ejecutarSiEsMovil() {
    const esMovil = window.matchMedia('(max-width: 1279.99px)').matches;
    if (esMovil) {
      this.mostrarTooltips();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.ejecutarSiEsMovil();
  }

  getDocumentos() {
    this.cantFilesUpload = 0;
    this.cantPhotosUpload = 0;
    this.fotosObligatorio = false;
    this.fotosOpcional = false;
    this._parametro
      .getDocumentosForUpload(this.isExpress ? 'express' : this.tipoPersona, this.idSolicitud, this.idEmpresario)
      .subscribe((data: any) => {
        if (data) {
          this.isDocumentos = true;
          this.documentos = data;
          this.tipoSolicitud = data.archivos[0].tipoDocumento;
          this.encabesadosSecciones();
          let idxVideo;
          this.documentos['archivos'].forEach((documento, i) => {
            if (
              documento.estado == 'HABILITADO' &&
              documento.obligatorio == 1 &&
              documento.neoDocumentosSolicitudDTO.length == 0
            ) {
              this.cantFilesUpload++;
            }
            if (
              documento.idTipoDocumento === 4 ||
              documento.idTipoDocumento === 12 ||
              documento.idTipoDocumento === 41
            ) {
              this.video = documento;
              idxVideo = i;
            }
            if (documento.multiple) {
              this.multiples.set(documento.idTipoDocumento, Array(documento.cantidadArchivos));
            }
            if (documento.idTipoDocumento == 17 || documento.idTipoDocumento == 21) {
              this.getPorcentajeProcesoSolicitud(this.tipoPersona);
            }
          });
          this.invalidFile = this.validDocuments(this.documentos['archivos']);
          if (idxVideo) {
            this.documentos['archivos'].splice(idxVideo, 1);
          }
          this.documentos['fotos'].forEach((foto) => {
            if (
              foto.estado == 'HABILITADO' &&
              foto.obligatorio == 1 &&
              foto.neoDocumentosSolicitudDTO.length == 0) {
              this.cantPhotosUpload++;
            }
            if (foto.obligatorio == 1 && foto.estado == 'HABILITADO') {
              this.fotosObligatorio = true;
            }
            if (foto.obligatorio == 0 && foto.estado == 'HABILITADO') {
              this.fotosOpcional = true;
            }
          });
          this.cantFiles = data['archivos'].length;
          if (this.cantFilesUpload == 0 && this.cantPhotosUpload == 0) {
            this._sweetAlert.infoModal(this.msjDocumentosAdicionales, false)
            this.habilitarBoton = true;
          } else {
            this.habilitarBoton = false;
          }
          this.documentos['archivos'] = this.documentos['archivos'].filter(
            (documento) => documento.idTipoDocumento != 4 && documento.idTipoDocumento != 12 && documento.idTipoDocumento != 41
          );
        }else{
          this._sweetAlert.errorModal("Error!",true,'No cargo la lista de documentos.');
          this.isDocumentos = false;
        }
      });
    if (this.isExpress) {
      this.getPorcentajeProcesoSolicitud('express');
    }
  }

  encabesadosSecciones(){
    this._bancoldexService.getGrupoTipoDocumetos(this.isExpress?'express':this.tipoPersona).subscribe((res:any)=>{
      this.listadoEncabesadosSecciones = res.data;
      this.ejecutarSiEsMovil();
    });
  }

  cargarTamanoArchivoMultimedia() {
    var json = {
      idParametro: 'PAR-056',
      nombre: null,
      isParFuncional: false,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.tamanoMaximoArchivosMultimediaReal = Number(respuesta[0].valorParametro);
        this.tamanoMaximoArchivosMultimedia =
          Number(respuesta[0].valorParametro) * Number(1048576);
      },
      (error) => {}
    );
  }

  cargarTamanoArchivo() {
    var json = {
      idParametro: 'PAR-122',
      nombre: null,
      isParFuncional: false,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.tamanoMaximoArchivosReal = Number(respuesta[0].valorParametro);
        this.tamanoMaximoArchivos =
          Number(respuesta[0].valorParametro) * Number(1048576);
      },
      (error) => {}
    );
  }

  cargarMsjDocumentosAdicionales() {
    var json = {
      idParametro: 'PAR-100',
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.msjDocumentosAdicionales = respuesta[0].valorParametro;
      },
      (error) => {}
    );
  }

  mensajeObservaciones() {
    var json = {
      idParametro: 'PAR-130',
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.msjObservacionesMicro = respuesta[0].valorParametro;
      },
      (error) => {}
    );
  }

  mensajeDocumentosErroneos() {
    var json = {
      idParametro: 'PAR-137',
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.msjDocumentosErroneos = respuesta[0].valorParametro;
      },
      (error) => {}
    );
  }

  //Methods CRUD

  saveFile(event, idTipoDocumento: number, key) {
    let archivo = false;
    let json: any = null;
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const filename = file.name.split('.');
    for (let index = 0; index < this.nombreArchivos.length; index++) {
      if (this.nombreArchivos[index].nombre == filename[0]) {
        archivo = true;
      }
    }
    if (key === 'fotos') {
      if (archivo === false) {
        const tipos = this.documentos[key].find(
          (d) => d.idTipoDocumento === idTipoDocumento
        );
        json = {
          idSolicitud: this.idSolicitud,
          idTipoDocumento: idTipoDocumento,
          tipoContenido: file.type,
          extension: filename[filename.length - 1],
          archivo: ''
        };
        reader.onload = () => {
          if (file.size >= 512000) {
            this.imgSize(reader.result).then((fileSize: number) => {
              json.archivo = this.archivoSeleccionado;
              this.cargarImg(json, tipos, file, filename, idTipoDocumento, fileSize);
          });
          } else {
            json.archivo = reader.result.toString().split(',')[1];
            this.cargarImg(json, tipos, file, filename, idTipoDocumento);
          }
        };
      } else {
        this._sweetAlert.errorModal("Error!", true, 'No puedes subir el mismo archivo.');
      }
    } else {
      if (archivo === false) {
        reader.onload = () => {
          const tipos = this.documentos[key].find(
            (d) => d.idTipoDocumento === idTipoDocumento
          );
          json = {
            idSolicitud: this.idSolicitud,
            nombreDocumento: tipos.nombreArchivoGuardado,
            idTipoDocumento: idTipoDocumento,
            tipoContenido: file.type,
            extension: filename[filename.length - 1],
            archivo: reader.result.toString().split(',')[1],
          };
          if (file.size <= this.tamanoMaximoArchivos) {
            if (tipos.tipoArchivoPermitido.indexOf(json.tipoContenido) >= 0 && json.tipoContenido != '' && json.tipoContenido.length>0) {
              this._microempresario.saveFile(json).subscribe((data: any) => {
                if (data.exitoso) {
                  this.cantFilesUpload++;
                  this.nombreArchivos.push({
                    id: data.idDocumentoSolicitud,
                    nombre: filename[0],
                    idTipoDocumento:idTipoDocumento
                  });
                  this._sweetAlert.successModal('Archivo subido');
                  this.getDocumentos();
                } else {
                  this._sweetAlert.errorModal("Error!",true,
                    !data.error ? 'No se pudo subir el archivo' : data.error
                  );
                }
              });
            } else {
              this._sweetAlert.errorModal("Error!",true,
                `Solo son permitidas las siguientes extensiones: ${tipos.extensionesValidas}`
              );
            }
          } else {
            this._sweetAlert.errorModal("Error!", true, `El archivo cargado supera el tamaño máximo
             permitido para documentos que es de ${this.tamanoMaximoArchivosReal} MB.`);
          }
        };
      } else {
        this._sweetAlert.errorModal("Error!",true,'No puedes subir el mismo archivo.');
      }
    }
  }

  cargarImg(json: any, tipos: any, file: any, filename: any, idTipoDocumento: any, fileSize?: any){
    let size: any = fileSize ? fileSize :file.size;
    if (size <= this.tamanoMaximoArchivosMultimedia) {
      if (tipos.tipoArchivoPermitido.indexOf(file.type) >= 0 && json.tipoContenido != '' && json.tipoContenido.length>0) {
        this._microempresario.saveFileAWS(json).subscribe((data: any) => {
          if (data.exitoso) {
            this.cantFilesUpload++;
            this.nombreArchivos.push({
              id: data.idDocumentoSolicitud,
              nombre: filename[0],
              idTipoDocumento:idTipoDocumento
            });
            this._sweetAlert.successModal('Archivo subido');
            this.getDocumentos();
          } else {
            this._sweetAlert.errorModal("Error!",true,
              !data.error ? 'No se pudo subir el archivo' : data.error
            );
          }
        });
      } else {
        this._sweetAlert.errorModal("Error!",true,
          `Solo son permitidas las siguientes extensiones: ${tipos.extensionesValidas}`
        );
      }
    } else {
      this._sweetAlert.errorModal("Error!", true,`El archivo cargado supera el tamaño máximo
       permitido para contenido multimedia que es de ${
        this.tamanoMaximoArchivosMultimediaReal} MB.`);
    }
  }

  seeDocument(idDocumento: string, nombreDocumento: string) {
    this._microempresario
      .downloadFile(idDocumento)
      .subscribe((response: any) => {
        const image: string = response.mimeType;
        if (
          response.mimeType === 'application/pdf' ||
          image.split('/')[0] === 'image'
        ) {
          const blob = new Blob([this.base64ToBytes(response.data)], {
            type: response.mimeType,
          });
          let urlFile = window.URL.createObjectURL(blob);
          this.route.navigate([]).then(() => window.open(urlFile));
        } else {
          var a = document.getElementById('downloadFile');
          a.setAttribute(
            'href',
            `data:${response.mimeType};base64,${response.data}`
          );
          a.setAttribute('download', unescape(nombreDocumento));
          a.click();
        }
      });
  }

  base64ToBytes(base64: string) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  deleteFile(idDocumento: string) {
    this._microempresario.deleteFile(idDocumento).subscribe((data: any) => {
      if (data.exitoso) {
        for (let i = 0; i < this.nombreArchivos.length; i++) {
          if (this.nombreArchivos[i].idTipoDocumento == idDocumento || this.nombreArchivos[i].id == idDocumento) {
            this.nombreArchivos.splice(i, 1);
          }
        }
        this.cantFilesUpload--;
        this._sweetAlert.successModal('Documento eliminado');
        this.getDocumentos();
      } else {
        this._sweetAlert.errorModal("Error!",true,data.error);
      }
    });
  }

  deleteFileAWS(idDocumento: string) {
    let json: any = null;
    json = {
      idSolicitud: this.idSolicitud,
      idTipoDocumento: idDocumento,
    };
    this._microempresario.deleteFileAWS(json).subscribe((data: any) => {
      if (data.exitoso) {
        for (let i = 0; i < this.nombreArchivos.length; i++) {
          if (this.nombreArchivos[i].idTipoDocumento == idDocumento || this.nombreArchivos[i].id == idDocumento) {
            this.nombreArchivos.splice(i, 1);
          }
        }
        this.cantFilesUpload--;
        this._sweetAlert.successModal('Documento eliminado');
        this.getDocumentos();
      } else {
        this._sweetAlert.errorModal("Error!",true,data.error);
      }
    });
  }

  saveSolicitud() {
    this._microempresario
      .crearSolicitud(this.idSolicitud)
      .subscribe((data: any) => {
        if (data.exitoso) {
          $('#aceptarModal').modal('hide');
          this.route.navigateByUrl('/LandingAceptacionCreacionCredito');
        } else {
          this._sweetAlert.errorModal("Error!",true,data.error);
        }
      });
  }
  //End Methods CRUD

  showAlert() {
    this._sweetAlert.successModal('Su solicitud ha sido actualizada');
  }

  goForm() {
    this.event.emit('back');
  }

  toArray(cant: number) {
    return new Array(cant);
  }

   validateForm() {
    if (this.cantFilesUpload == 0 && this.cantPhotosUpload == 0 && this.isDocumentos == true) {
      if(this.invalidFile > 0){
        this._sweetAlert.errorModal("Error!", true,"Los documentos cargados presentan inconsistencias, por favor revise nuevamente")
      } else {
        $('#aceptarModal').modal('show');
      }
    } else {
      this._sweetAlert.errorModal("Error!",true,
        'Documentos obligatorios (*) incompletos, no se puede enviar solicitud hasta terminar el proceso.'
      );
    }
  }

  saveVideo(event, key: string) {
    let tipoDoc: number;
    if(this.isExpress){
      tipoDoc = 41;
    }
    else if (this.tipoPersona === 'natural') {
      tipoDoc = 4;
    } else {
      tipoDoc = 12;
    }
    let archivo = false;
    let json: any = null;
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const filename = file.name.split('.');
    for (let index = 0; index < this.nombreArchivos.length; index++) {
      if (this.nombreArchivos[index].nombre === filename[0]) {
        archivo = true;
      }
    }
    if (archivo === false) {
      const tipos = this.video;
      reader.onload = () => {
        json = {
          idSolicitud: this.idSolicitud,
          idTipoDocumento: tipoDoc,
          tipoContenido: file.type,
          extension: filename[filename.length - 1],
          archivo: reader.result.toString().split(',')[1],
        };
        if (file.size <= this.tamanoMaximoArchivosMultimedia) {
          if (tipos.tipoArchivoPermitido.indexOf(file.type) >= 0 && json.tipoContenido != '' && json.tipoContenido.length>0) {
            this._microempresario.saveFileAWS(json).subscribe((data: any) => {
              if (data.exitoso) {
                this.nombreArchivos.push({
                  id: data.idDocumentoSolicitud,
                  nombre: filename[0],
                  idTipoDocumento:tipoDoc
                });
                this.cantFilesUpload++;
                this._sweetAlert.successModal('Archivo subido');
                this.getDocumentos();
              } else {
                this._sweetAlert.errorModal("Error!",true,
                  !data.error ? 'No se pudo subir el archivo' : data.error
                );
              }
            });
          } else {
            this._sweetAlert.errorModal("Error!",true,
              `Solo son permitidas las siguientes extensiones: ${tipos.extensionesValidas}`
            );
          }
        } else {
          this._sweetAlert.errorModal("Error!",true,
            `El archivo pesa ${Math.trunc(
              file.size / Number(1048576)
            )} MB supera el tamaño máximo permitido para contenido multimedia que es de ${
              this.tamanoMaximoArchivosMultimediaReal
            } MB`
          );
        }
      };
    } else {
      this._sweetAlert.errorModal("Error!",true,'No puedes subir el mismo archivo.');
    }
  }

  getMensajeEnvio() {
    var json = {
      idParametro: mensajeEnvioSolicitud,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.mensajeEnvio = respuesta[0].valorParametro;
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
  }

  goBack(){
    this._location.back();
  }

  getPorcentajeProcesoSolicitud(tipoPersona:string){
    this._microempresario.getPorcentajeSolicitudProceso(
      tipoPersona,
      +this._user.getUser().idEmpresario,)
    .subscribe((response:any)=>{
      if(response.exitoso){
        this.porcentajeProcesoSolicitud = response.porcentaje;
      }
      if(response.exitoso==false && response.porcentaje==null){
        this.porcentajeProcesoSolicitud=0;
      }
    },(error)=>{
      this._sweetAlert.errorModal('Error',true,"Ocurrió un error en el servicio");
    });
  }

  validDocuments(documento:any):number{
    let contador:number =0;
    documento.forEach((elemento:any)=>{
      if(elemento.obligatorio){
        elemento.neoDocumentosSolicitudDTO.forEach((aux:any)=>{
          if(aux.habilitado == 0){
            contador++;
          }
        })
      }
    })
    return contador;
  }

  async imgSize(archivo): Promise<number> {
    // Usa await para esperar a que la compresión de la imagen se complete
    const result = await this.imageCompress.compressFile(archivo, 0);
    this.archivoSeleccionado = result.toString().split(',')[1];
    const blob = this.dataURItoBlob(result);
    const fileSize = blob.size;
    return fileSize;
  }

  // Función auxiliar para convertir una URL de datos a un objeto Blob
  dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }

  cargarObservaciones(){
    this._microempresario.getObservacionesMicro(this.idSolicitud).subscribe((resp: any) =>{
      if (resp.exitoso) {
        this.observacionesForm.get('observacionesMicroempresario').setValue(resp.observaciones);
      }
    });
  }

  guardarObservaciones(){
    this._microempresario.guardarObservacionesMicro(this.observacionesForm.value).subscribe((resp: any) => {
      if (resp.exitoso) {
        this._sweetAlert.successModal('Observaciones guardadas.');
      }
    });
  }
}
